import { useCallback } from 'react'

import { useTrialTour } from '@/modules/projects/components/trial/TrialTour/useTrialTour'
import { useOpenOverviewWhenTrialFinishes } from './useOpenOverviewWhenTrialFinishes'

// A finished trial run plays the celebration, and the results tour starts as soon as it goes away.
export const useTrialFinish = () => {
  const { isCelebrating, endCelebration, isPreview } =
    useOpenOverviewWhenTrialFinishes()
  const { isRunning, start, end } = useTrialTour(isPreview)

  const finishCelebration = useCallback(() => {
    endCelebration()
    start()
  }, [endCelebration, start])

  return {
    isCelebrating,
    finishCelebration,
    isTourRunning: isRunning,
    endTour: end,
  }
}
